import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { WidgetService } from '../../../../../../_services/review-services/widget.service';
import { UtilityService } from '../../../../../../_services/utility.service';

@Component({
  selector: 'app-profile-widget',
  templateUrl: './profile-widget.component.html',
  styleUrls: ['./profile-widget.component.css']
})
export class ProfileWidgetComponent {
  @Input() chosenUser?: string;
  @Input() selectedReviewId: number;
  @Input() isVisible: boolean;
  @Output() hasLastReview: EventEmitter<boolean> = new EventEmitter<boolean>();

  lastReview: string;
  user: { name: string; role: string; img_path: string };
  activeProjects: { id: number; alias: string; img_path: string }[];
  pastProjects: { id: number; alias: string; img_path: string }[];

  constructor(
    private readonly widgetService: WidgetService,
    private readonly utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    if (!this.chosenUser) {
      this.getProfileCardData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isVisible &&
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      changes['selectedReviewId']?.currentValue
    ) {
      this.getProfileCardData();
    }
  }

  getProfileCardData(): void {
    this.widgetService
      .getProfileCardData(this.selectedReviewId, this.chosenUser)
      .subscribe(data => {
        this.user = data.user;
        this.lastReview = data.last_review;
        this.pastProjects = data.past_projects;
        this.activeProjects = data.active_projects;

        this.lastReview
          ? this.hasLastReview.emit(true)
          : this.hasLastReview.emit(false);
      });
  }

  getSanitizeUrl(url: string): SafeUrl {
    return this.utilityService.getSanitizeUrl(url);
  }
}
